import { createSlice } from "@reduxjs/toolkit";
import { sleep } from "../../common/utils/utils";
import { getAPI } from "../../api/nodeRedApi/axiosApi";

import {
  getLogs as getLogsAPI,
} from "../../api/nodeRedApi/logs";

export const logsSlice = createSlice({
  name: "logs",
  initialState: {
    loader: null,
    error: null,
    logs: null,
  },
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },

    setLogs: (state, action) => {
      state.logs = action.payload;
    },
  },
});

export const { setLoader, setError, setLogs } = logsSlice.actions;

export const getLogs = (project, type) => async (dispatch) => {

  console.log("GET");
  dispatch(setLoader("LOADING"));
  let logs = [];
  let api = getAPI(project?.id);
  if (api) {
    logs = await getLogsAPI(api, type);
  } else {
    await sleep(1000);
  }
  dispatch(setLogs(logs));
  dispatch(setLoader(null));
};

export const selectLoader = (state) => state.logs.loader;
export const selectError = (state) => state.logs.error;
export const selectLogs = (state) => state.logs.logs;
export const selectSelectedProject = (state) => state.authentication.selectedProject;

export default logsSlice.reducer;
